import Image from "next/image";
import { buildImageSrc, getImageDimensions } from "~lib/storyblok";
import type { ShowcaseSectionBlok } from "../types";

interface ShowcaseSectionImageProps {
  blok: ShowcaseSectionBlok;
}

const heroImageVariants = {
  sticky: "lg:-translate-y-1/2 z-10 lg:sticky lg:top-1/2",
  banner:
    "z-10 object-contain object-bottom lg:absolute lg:bottom-[0] lg:h-[90%]",
};

const getImagePosition = (blok: ShowcaseSectionBlok) => {
  const { imagePosition, isBanner = false } = blok;

  if (imagePosition === "sticky" || imagePosition === "banner") {
    return imagePosition;
  }

  return isBanner ? "banner" : "sticky";
};

function ShowcaseSectionImage({ blok }: ShowcaseSectionImageProps) {
  const displayImage = !blok.video?.filename && blok.image?.filename;
  const srcImage = buildImageSrc(blok.image.filename ?? "", {
    focus: blok.image.focus,
  });

  const imagePosition = getImagePosition(blok);
  const imageClass = heroImageVariants[imagePosition];

  return displayImage ? (
    <Image
      sizes="(max-width: 1024px) 100vw, 50vw"
      src={srcImage}
      {...getImageDimensions(blok.image)}
      alt={blok.image.alt ?? ""}
      className={imageClass}
    />
  ) : null;
}

export { ShowcaseSectionImage };
